<template>
  <div class="formViewBox" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <el-form :model="data.form" status-icon :rules="rules" label-position="top" label-width="100px"
      class="demo-ruleForm" ref="formRef">
      <el-form-item :label="data.form.titleValue ? data.form.name.title : ''" prop="name">
        <el-input :style="inputStyle" type="text" v-model="data.form.name.tipTxt" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="data.form.titleValue ? data.form.phone.title : ''" prop="phone">
        <el-input type="text" v-model="data.form.phone.tipTxt" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-for="(item, index) in data.form.content" :label="data.form.titleValue ? item.title : ''"
        :key="index" prop="content" :rules="{
          required: item.visible ? true : false, message: '', trigger: 'blur'
        }">
        <!-- 多行文本 -->
        <el-input v-if="item.type === '1'" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }"
          v-model.number="item.tipTxt"></el-input>
        <!-- 单行文本 -->
        <el-input v-if="item.type === '2'" v-model.number="item.tipTxt"></el-input>
        <!-- 单选 -->
        <el-radio-group v-if="item.type === '3'" v-model="item.radioVal">
          <el-radio v-for="(radioItm, index) in item.radioMap" :key="index" :label="radioItm.value">
            {{ radioItm.text }}
          </el-radio>
        </el-radio-group>
        <!-- 多选 -->
        <el-checkbox-group v-model="item.checkboxGroup" v-if="item.type === '4'">
          <el-checkbox-button v-for="(group, groupIdx) in item.groups" :label="group.value" :key="groupIdx">{{
            group.text }}</el-checkbox-button>
        </el-checkbox-group>
        <!-- 下拉选择 -->
        <el-select v-model="item.selectVal" v-if="item.type === '5'">
          <el-option v-for="item in item.selectOptions" :key="item.value" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
        <!-- 邮箱 -->
        <el-input v-if="item.type === '6'" type="email" v-model.number="item.tipTxt"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 100%; border: none; margin-top: 10px;" :style="{ backgroundColor: data.form.btnColor }"
          type="primary" @click="submitForm('ruleForm')">{{
            data.form.btnName }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'formView',
  props: {
    data: Object
  },
  data () {
    return {
      ruleForm: {
        name: '',
        phone: '',
        content: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'data.form.mbColor': function (newVal) {
      // 当输入内容变化时，设置边框颜色
      this.updateInputBorderColor()
    },
    'data.form.inputStyle': function (newVal) {
      // 当输入内容变化时，设置边框颜色
      this.updateInputBorderColor()
    },
    'data.form.tcColor': function (newVal) {
      // 当输入内容变化时，设置边框颜色
      this.updateInputBorderColor()
    }
  },
  methods: {
    updateInputBorderColor () {
      const inputElement = this.$refs.formRef.$el.querySelectorAll(
        '.el-input__inner'
      )
      const textareaElement = this.$refs.formRef.$el.querySelectorAll(
        '.el-textarea__inner'
      )
      if (inputElement || textareaElement) {
        if (this.data.form.inputStyle === '描边') {
          inputElement.forEach(element => {
            element.style.borderColor = this.data.form.mbColor
            element.style.backgroundColor = '#ffffff'
          })
          textareaElement.forEach(element => {
            element.style.borderColor = this.data.form.mbColor
            element.style.backgroundColor = '#ffffff'
          })
        }
        if (this.data.form.inputStyle === '填充') {
          inputElement.forEach(element => {
            element.style.borderColor = 'transparent'
            element.style.backgroundColor = this.data.form.tcColor
          })
          textareaElement.forEach(element => {
            element.style.borderColor = 'transparent'
            element.style.backgroundColor = this.data.form.tcColor
          })
        }
      }
    }
  },
  mounted () {
    // 组件挂载后，初始设置边框颜色
    this.updateInputBorderColor()
  },
  updated () {
    // 更新后，重新设置边框颜色
    this.updateInputBorderColor()
  },
  computed: {
    inputStyle () {
      return {
        'border-color': this.data.form.mbColor
      }
    }
  }
}
</script>

<style scoped>
.formViewBox {
  padding: 15px;
}

.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-checkbox-button {
  margin-right: 10px;
}

/deep/ .el-checkbox-button .el-checkbox-button__inner {
  border: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/formPreview.vue